export const initialState = () => ({
  preferredLipidsUnit: null,
  preferredGlucoseUnit: null,
});

export default initialState();
